export const getters = {
    getNCM: state => state.NCM,
    getNCMs: state => state.NCMs,
    getModalCadastroNCM: state => state.modalCadastrarNCM,
    getModalExcluirNCM: state => state.modalExcluirNCM,
    getModalPesquisarNCM: state => state.modalPesquisarNCM,
    getModalAtualizarTabelaNCM: state => state.modalAtualizarTabelaNCM
}

export default {}